/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 23 2023
 **/

import styled from "@emotion/styled";
import { ZIndex } from "@/frameworks/core/commons";
import { Column, Menu, Row } from "@/frameworks/designStuff/components";

export const FullSizeChatLayout = styled(Column)`
	position: relative;
	width: 100%;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.neutral_00_80};
	filter: drop-shadow(12px 0px 20px rgba(0, 0, 0, 0.16));
	backdrop-filter: blur(14px);
	z-index: ${ZIndex.FULL_SIZE_CHAT};
`;
export const MenuItem = styled(Menu.Item)`
	width: 100%;
	.buttonText {
		width: 100%;
		text-align: left;
	}
`;

export const TabItemBox = styled(Row)`
	height: 28px;
`;

export const ChatLayout = styled.div<{ hasThread: boolean; width: number }>`
	width: ${({ hasThread, width }) => (hasThread ? `calc(100% - ${width}px)` : "100%")};
	height: 100%;
	min-width: 360px;
`;

export const ThreadLayout = styled.div<{ width: number }>`
	width: ${({ width }) => `${width}px`};
	height: 100%;
	box-shadow: 0 0 4px rgba(0, 0, 0, 0.08);
	min-width: 360px;
`;
